import modules from './no/index';

export default
{
  'io':
    modules.io,


  'layout.navigation.topbar':
    modules.layout.navigation.topbar,

  'layout.navigation.sidebar':
    modules.layout.navigation.sidebar,


  'component.module.artist.trackEditor':
    modules.component.module.artist.trackEditor,


  'component.module.artist.misc.TrackSearcher':
    modules.component.module.artist.misc.TrackSearcher,

  'component.module.artist.misc.TrackStripLabels':
    modules.component.module.artist.misc.TrackStripLabels,

  'component.module.artist.misc.TrackStrip':
    modules.component.module.artist.misc.TrackStrip,

  'page.portal':
    modules.page.portal,

  'page.home':
    modules.page.home,

  'page.artist.management.tracks':
    modules.page.artist.management.tracks,
}



// WEBPACK FOOTER //
// ./src/locales/no.js